/**
 * @generated SignedSource<<ddedc87a4159eb73f26313774687d3e9>>
 * @relayHash 683e4da8626dcc0d474626254f8c4451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84693c66373eb6838bde9f4971edaeeae3cd72edb831112d21dce98c601aee8e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraRemoveIssuesFromAllFixVersionsInput = {
  issueIds: ReadonlyArray<string>;
};
export type useRemoveIssuesFromAllVersionsMutation$variables = {
  boardId: string;
  input: JiraRemoveIssuesFromAllFixVersionsInput;
};
export type useRemoveIssuesFromAllVersionsMutation$data = {
  readonly jira: {
    readonly removeIssuesFromAllFixVersions: {
      readonly issueUpdateResults: ReadonlyArray<{
        readonly issueId: string;
        readonly updated: boolean;
      }> | null | undefined;
      readonly success: boolean;
      readonly versions: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"content_softwareVersionBacklogPanelRelay_jiraVersionFragment">;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useRemoveIssuesFromAllVersionsMutation = {
  response: useRemoveIssuesFromAllVersionsMutation$data;
  variables: useRemoveIssuesFromAllVersionsMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": isManageVersionsPermissionEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isManageVersionsPermissionEnabled_provider from '@atlassian/jira-relay-provider/src/is-manage-versions-permission-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "JiraVersionIssueUpdateResult",
  "kind": "LinkedField",
  "name": "issueUpdateResults",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "kind": "ScalarField",
      "name": "updated"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useRemoveIssuesFromAllVersionsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
            "kind": "LinkedField",
            "name": "removeIssuesFromAllFixVersions",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "content_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useRemoveIssuesFromAllVersionsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
            "kind": "LinkedField",
            "name": "removeIssuesFromAllFixVersions",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "versionId"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "releaseDate"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                      }
                    ],
                    "concreteType": "JiraVersionStatistics",
                    "kind": "LinkedField",
                    "name": "statistics",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "doneEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "percentageCompleted"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "notEstimated"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "done"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalIssueCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "toDo"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "inProgress"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v6/*: any*/),
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "alias": "editProjectConfig",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                              }
                            ],
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                          }
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "canManageVersions",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "type",
                                "value": "MANAGE_VERSIONS"
                              }
                            ],
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "84693c66373eb6838bde9f4971edaeeae3cd72edb831112d21dce98c601aee8e",
    "metadata": {},
    "name": "useRemoveIssuesFromAllVersionsMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": isManageVersionsPermissionEnabled_provider
    }
  }
};
})();

(node as any).hash = "d60aafd65f63c4583af72cc4c256ebbf";

export default node;
